import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import SVGPreview from "../ui/svg-preview";

interface LoaderSkeletonProps {
  className?: string;
}

export const LoaderSkeleton: React.FC<LoaderSkeletonProps> = ({
  className,
}) => {
  return (
    <Card
      className={`flex flex-row h-20 w-full items-center border-0 rounded-lg shadow-sm bg-surface-elevated animate-pulse ${className}`}
    >
      {/* Icon placeholder */}
      <CardContent className="flex rounded-tl-lg rounded-bl-lg items-center justify-center p-3 w-14 h-full bg-surface-dark">
        <div className="w-10 h-10 rounded-md bg-surface-active/50" />
      </CardContent>

      {/* Text placeholders */}
      <div className="flex flex-col flex-grow px-3 space-y-2">
        <div className="h-4 w-3/4 rounded-md bg-surface-active/50" />
        <div className="h-3 w-1/2 rounded-md bg-surface-active/30" />
      </div>
    </Card>
  );
};

interface ProjectLoaderSkeletonProps {
  className?: string;
}

export const ProjectLoaderSkeleton: React.FC<ProjectLoaderSkeletonProps> = ({
  className,
}) => {
  return (
    <Card
      className={`overflow-hidden border-none rounded-xl shadow-md flex flex-col w-full h-full animate-pulse ${className}`}
    >
      <CardContent className="flex-grow flex items-center justify-center bg-surface-dark p-4" />
    </Card>
  );
};

export const DiagramLoader = () => (
  <li className="animate-pulse flex items-center p-4 rounded-md gap-4 hover:bg-surface-hover cursor-pointer">
    <div className="w-[76px] h-[76px] bg-surface-border rounded-md flex-shrink-0">
      <SVGPreview
        className="w-full h-full object-cover bg-surface-input"
        svgContent=""
      />
    </div>
    <div className="flex flex-col gap-1 flex-grow">
      <div className="h-5 bg-surface-border rounded-md my-1"></div>
      <div className="h-2 bg-surface-border rounded-md w-1/2"></div>
      <div className="h-1 bg-surface-border rounded-md w-1/3"></div>
    </div>
  </li>
);
export const ShapesLoadingSkeleton = () => {
  return (
    <div className="flex flex-col p-1 rounded-lg hover:bg-surface-hover mb-2 relative aspect-[3/2] transition-all hover:scale-105 focus:outline-none animate-pulse">
      <SVGPreview
        className="w-full h-full object-cover bg-surface-input"
        svgContent=""
      />
      <div className="h-2 bg-surface-border rounded-md my-1"></div>
      <div className="h-1 bg-surface-border rounded-md w-1/4"></div>
    </div>
  );
};
